/* ============
 * Actions for the Unit-types module
 * ============
 *
 * The actions that are available on the
 * Unit-types module.
 */

import axios from 'axios';
import { apiEndpointConst, authHeader } from '@/utils/urls';
import { generateInit } from '@/store/utils';
import * as types from './mutation-types';
import { production } from '../../environment';

function apiEndpoint(order, lang) {
  return production
    ? apiEndpointConst(order, 'unit_type', lang ? `?lang=${lang}` : '')
    : `/api-proxy/${order}/data/unit_type${lang ? `?lang=${lang}` : ''}`;
}

function panoramaApiEndpoint(unitTypeId) {
  return production
    ? apiEndpointConst(unitTypeId, 'panorama_unit', '')
    : `/api-proxy/${unitTypeId}/data/panorama_unit`;
}

export function load({ state, commit }, { order, lang }) {
  return axios
    .get(apiEndpoint(order, lang), { headers: authHeader })
    .then((res) => {
      commit(types.LOAD, res.data);
      return res.data;
    });
}

export const loadPanorama = ({ commit }, { unitTypeId }) => axios
  .get(panoramaApiEndpoint(unitTypeId), { headers: authHeader })
  .then((res) => {
    commit(types.LOAD_PANORAMA, { unitTypeId, panorama: res.data });
    return res.data;
  });

export default {
  load,
  loadPanorama,
  init: generateInit('unitTypes'),
};
